<template>
    <div>
      <div class="row mb-5">
        <div class="col-8">
            <h2 class="content-title card-title mb-0">{{ $t("common.dashboard") }}</h2>
        </div>
        <div class="col-4">
            <a-range-picker :allowClear="false" size="large" format="YYYY-MM-DD" 
            :default-value="dateRangeDefault" @change="rangePicker"
            />
        </div>
    </div>
      <div class="row" v-if="dashboardData && dashboardData.order_summery"> 
        <div class="col-lg-4">
            <div class="card card-body mb-4">
                <article class="icontext">
                    <span class="icon icon-sm rounded-circle bg-success-light"><i class="text-success material-icons md-local_shipping"></i></span>
                    <div class="text">
                        <h6 class="mb-1 card-title">Total Orders</h6> 
                        <span>{{dashboardData.order_summery.total_orders || 0}}</span>
                        <!-- <span class="text-sm">
                              Default current date
                        </span> -->
                    </div>
                </article>
            </div>
        </div>
        <div class="col-lg-4">
            <div class="card card-body mb-4">
                <article class="icontext">
                    <span class="icon icon-sm rounded-circle bg-warning-light"><i class="text-warning material-icons md-pending_actions"></i></span>
                    <div class="text">
                        <h6 class="mb-1 card-title">Total Pending Orders</h6> 
                        <span>{{dashboardData.order_summery.Pending}}</span>
                        <!-- <span class="text-sm">
                            Total pending orders of all time
                        </span> -->
                    </div>
                </article>
            </div>
        </div>
        <div class="col-lg-4">
            <div class="card card-body mb-4">
                <article class="icontext">
                    <span class="icon icon-sm rounded-circle bg-primary-light"><i class="text-primary material-icons md-assignment"></i></span>
                    <div class="text">
                        <h6 class="mb-1 card-title">Total Assigned orders</h6> 
                        <span>{{dashboardData.order_summery.Assigned}}</span>
                        <!-- <span class="text-sm">
                            In 19 Categories
                        </span> -->
                    </div>
                </article>
            </div>
        </div>
        <div class="col-lg-4">
            <div class="card card-body mb-4">
                <article class="icontext">
                    <span class="icon icon-sm rounded-circle bg-info-light"><i class="text-info material-icons md-directions_transit"></i></span>
                    <div class="text">
                        <h6 class="mb-1 card-title">Total In Transit orders</h6> 
                        <span> {{dashboardData.order_summery.Picked}}</span>
                        <!-- <span class="text-sm">
                            Based in your local time.
                        </span> -->
                    </div>
                </article>
            </div>
        </div>
        <div class="col-lg-4">
            <div class="card card-body mb-4">
                <article class="icontext">
                    <span class="icon icon-sm rounded-circle bg-primary-light"><i class="text-primary material-icons md-done"></i></span>
                    <div class="text">
                        <h6 class="mb-1 card-title">Total Delivered orders</h6>
                        <span>{{dashboardData.order_summery.Delivered}}</span>
                        <!-- <span class="text-sm">
                            Shipping fees are not included
                        </span> -->
                    </div>
                </article>
            </div>
        </div>
        <div class="col-lg-4">
            <div class="card card-body mb-4">
                <article class="icontext">
                    <span class="icon icon-sm rounded-circle bg-1"><i class="text-pink material-icons md-restore"></i></span>
                    <div class="text">
                        <h6 class="mb-1 card-title">Total Reconciled orders</h6>
                        <span>{{dashboardData.order_summery.Reconciled}}</span>
                        <!-- <span class="text-sm">
                            Shipping fees are not included
                        </span> -->
                    </div>
                </article>
            </div>
        </div>
        <div class="col-lg-4">
            <div class="card card-body mb-4">
                <article class="icontext">
                    <span class="icon icon-sm rounded-circle alert-danger"><i class="text-danger material-icons md-error"></i></span>
                    <div class="text">
                        <h6 class="mb-1 card-title">Total Failed orders</h6>
                        <span>{{dashboardData.order_summery.Failed}}</span>
                        <!-- <span class="text-sm">
                            Shipping fees are not included
                        </span> -->
                    </div>
                </article>
            </div>
        </div>
        <div class="col-lg-4">
            <div class="card card-body mb-4">
                <article class="icontext">
                    <span class="icon icon-sm rounded-circle bg-4"><i class="text-purple material-icons md-assignment_turned_in"></i></span>
                    <div class="text">
                        <h6 class="mb-1 card-title">Total Reassigned orders</h6>
                        <span>{{dashboardData.order_summery.Reassigned}}</span>
                        <!-- <span class="text-sm">
                            Shipping fees are not included
                        </span> -->
                    </div>
                </article>
            </div>
        </div>
        <div class="col-lg-4">
            <div class="card card-body mb-4">
                <article class="icontext">
                    <span class="icon icon-sm rounded-circle bg-5"><i class="text-bg-5 material-icons md-keyboard_return"></i></span>
                    <div class="text">
                        <h6 class="mb-1 card-title">Total Returned orders</h6>
                        <span>{{dashboardData.order_summery.Returned}}</span>
                        <!-- <span class="text-sm">
                            Shipping fees are not included
                        </span> -->
                    </div>
                </article>
            </div>
        </div>
    </div>

    <div class="card mb-4">
      <header class="card-header">
          <div class="d-flex justify-content-between align-items-center">
              <h4 class="card-title">Latest orders</h4>
              <router-link to="/order-list" class="btn btn-outline-primary px-4">View ALL</router-link>
          </div>
      </header>
      <div class="card-body" v-if="dashboardData && dashboardData.orders.length">
          <div class="table-responsive">
              <div class="table-responsive">
                  <table class="table align-middle table-nowrap mb-0 order-table">
                      <thead class="table-light">
                          <tr> 
                              <th class="align-middle" scope="col">Order ID</th> 
                              <th class="align-middle" scope="col">Delivert Date</th> 
                              <th class="align-middle" scope="col">Delivary Schedule</th>  
                              <th class="align-middle" scope="col">Product Quantity</th>    
                              <th class="align-middle" scope="col">Payment Type</th>   
                              <th class="align-middle" scope="col">Status</th>  
                              <th class="align-middle" scope="col">View Details</th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr v-for="order in dashboardData.orders" :key="order.id"> 
                              <td><router-link :to="'/order-deatils/'+order.id" class="fw-bold">{{order.unique_id}}</router-link></td>
                              <td>{{order.delivery_date}}</td> 
                              <td>{{order.delivery_schedule}}</td> 
                              <td>{{order.details.length}}</td>  
                              <td>{{order.payment_type}}</td>
                              <td>
                                  {{order.order_status.name}}
                              </td> 
                              <td>
                                  <router-link :to="'/order-deatils/'+order.id" class="btn btn-xs btn-outline-primary">View Details</router-link>
                              </td>
                          </tr>
                      </tbody>
                  </table>
              </div>
          </div> <!-- table-responsive end// -->
      </div>
    </div>

    <div class="row hide">
        <div class="col-xl-8 col-lg-4 col-sm-12">
            <div class="card mb-4">
                <article class="card-body">
                    <h5 class="card-title">Order forecast by category for tomorrow</h5>
                    <!-- <canvas id="myChart" height="120px"></canvas> -->
                    <AreaChart></AreaChart>
                </article>
            </div> 
        </div>
        <div class="col-xl-4 col-lg-12">
            <div class="card mb-4 ">
                <article class="card-body">
                    <h5 class="card-title">Forecast vs reality</h5>
                    <!-- <canvas id="myChart2" height="270"></canvas> -->
                    <BarChart></BarChart>
                </article>
            </div> 
        </div> 
    </div>

  </div>
</template>
<script>
import AreaChart from "../../components/AreaChart.vue";
// import PieChart from "../../components/PieChart.vue";
import BarChart from "../../components/BarChart.vue";
// import RadarChart from "../../components/RadarChart.vue";
// import LineChart from "../../components/LineChart.vue"
import { DASHBOARD } from "../../../script/api";
import { getData } from "../../../script/api-service";
import {DateFormat} from "../../../script/helper";
import moment from "moment";


export default {
    data() {
        return {
            chartData: {
                Books: 24,
                Magazine: 30,
                Newspapers: 10
            },
            dashboardData: null,
            dateRangeDefault: [moment(), moment()],
            fromDate: moment().format('YYYY-MM-DD'),
            toDate: moment().format('YYYY-MM-DD')
        };
    },
    components: {
        AreaChart,
        // PieChart,
        BarChart,
        // RadarChart,
        // LineChart
    },
    methods: {
        async getDashboardData() {
            let res = await getData(DASHBOARD + `?from_date=${this.fromDate}&to_date=${this.toDate}`);

            if (res) {
                let masterData = res.data.data;
                this.dashboardData = masterData;
            }
        },
        dateFormat(date) {
            return DateFormat(date)
        },
        rangePicker(_, dateString) {
            this.fromDate = dateString[0];
            this.toDate = dateString[1];

            this.getDashboardData();
        }
    },
    mounted() {
        this.getDashboardData();
    }
}
</script>